import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  cats: {
    id: UpgradeType.Cats,
    icon: [''],
    cost: { gold: 0 },
    costGrowthRate: 1000,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 3,
    purchaseLimit: 1,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
};
